import React from "react";
import { Box, IconButton } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import { setTouchControl, controlsState, CarControlsState } from "./controls";
import { initAudio } from "./audio";

const TouchButton: React.FC<{
  control: keyof CarControlsState;
  icon: React.ReactNode;
  sx?: object;
}> = ({ control, icon, sx }) => {
  const press = (e: React.SyntheticEvent) => {
    e.preventDefault();
    initAudio();
    if (control === "jump") {
      controlsState.jump = true;
    } else {
      setTouchControl(control, true);
    }
  };
  const release = (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (control !== "jump") setTouchControl(control, false);
  };

  return (
    <IconButton
      onPointerDown={press}
      onPointerUp={release}
      onPointerLeave={release}
      onPointerCancel={release}
      sx={{
        width: 56,
        height: 56,
        backgroundColor: "rgba(145, 189, 58, 0.85)",
        color: "white",
        touchAction: "none",
        "&:hover": { backgroundColor: "rgba(145, 189, 58, 0.95)" },
        "&:active": { backgroundColor: "#7da432" },
        ...sx,
      }}
    >
      {icon}
    </IconButton>
  );
};

const TouchControls: React.FC = () => {
  return (
    <Box
      sx={{
        display: { xs: "flex", md: "none" },
        position: "fixed",
        bottom: 24,
        left: 0,
        right: 0,
        justifyContent: "space-between",
        px: 3,
        zIndex: 20,
        pointerEvents: "none",
        "& > *": { pointerEvents: "auto" },
      }}
    >
      <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
        <TouchButton control="left" icon={<ArrowBackIcon />} />
        <TouchButton control="right" icon={<ArrowForwardIcon />} />
      </Box>
      <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1.5 }}>
        <TouchButton control="jump" icon={<KeyboardDoubleArrowUpIcon />} sx={{ width: 46, height: 46 }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <TouchButton control="forward" icon={<ArrowUpwardIcon />} />
          <TouchButton control="backward" icon={<ArrowDownwardIcon />} />
        </Box>
      </Box>
    </Box>
  );
};

export default TouchControls;
